var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"doctor-messages"}},[_c('el-row',[_c('el-col',{attrs:{"span":4}},[_c('Folders')],1),_c('el-col',{attrs:{"span":8}},[_c('Messages')],1),_c('el-col',{attrs:{"span":12}},[_c('Detail')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }